import Farm from "../../components/Farms/Farm";
import useFarms from "../../hooks/useFarms";
import { SingleFarmProvider } from "../../contexts/SingleFarmContext";
import React, { useEffect, useState } from "react";
import { formatLongNumber } from "../../utils/utils";
import { makeStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import Grid from "@mui/material/Grid";
import Alert from "@mui/material/Alert";

const styles = makeStyles((theme) => ({}));

const FarmsList = ({ value }) => {
  const classes = styles();
  const [farmObjects, setFarmObjects] = useState([]);
  const [sortFunction, setSortFunction] = useState("default");

  const { farmConfig, globalFarmStats, isInitGlobalStatsLoaded, farms, tvl } =
    useFarms();
  const [sorted, setsorted] = useState(farmConfig.farms);

  useEffect(() => {
    setsorted([...farms]);
  }, [farms, farmConfig]);

  useEffect(() => {
    setFarmObjects(
      farmConfig.farms.map((farm) => {
        return (
          <SingleFarmProvider pid={farm.pid} key={farm.name}>
            <Farm expandable />
          </SingleFarmProvider>
        );
      })
    );
  }, [farmConfig, farms]);

  return (
    <>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{ textAlign: "center", padding: 0 }}
      >
        {tvl || tvl == 0 ? (
          <Typography variant={"h4"} style={{ width: "100%" }}>
            TVL: ${formatLongNumber(tvl, 3)}
          </Typography>
        ) : (
          <Skeleton
            animation={"wave"}
            style={{
              minWidth: 96,
              minHeight: 40,
              width: "30%",
              margin: "auto",
            }}
          />
        )}
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{ marginBottom: 16, marginTop: 16 }}
      >
        {isInitGlobalStatsLoaded && globalFarmStats.paused && (
          <Alert severity={"warning"}>
            Farms have been paused by admin, All funds are secure and all users will
            be able to interact with the farm once unpause{" "}
            {/*, users also can use the emergency withdraw but that will forfeit
            their rewards, we suggest waiting for the problem to be fixed*/}
          </Alert>
        )}
        {isInitGlobalStatsLoaded && globalFarmStats.inEmergency && (
          <Alert severity={"error"}>
            Farm is in Emergency mode, users can use the emergency withdraw but that
            will forfeit their rewards, we suggest waiting for the problem to be
            fixed
          </Alert>
        )}
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginBottom: 16 }}>
        {isInitGlobalStatsLoaded && !globalFarmStats.hasStarted && (
          <Alert severity={"success"}>Farms not started yet stay tuned!</Alert>
        )}

        {isInitGlobalStatsLoaded &&
          !globalFarmStats.active &&
          globalFarmStats.hasStarted && (
            <Alert severity={"warning"}>
              Farms have expired deposits have been disabled, Check the active farms
              tab to see new active farms!
            </Alert>
          )}
      </Grid>
      {sorted.map((farm, index) => {
        if (farm.active) return farmObjects[farm.pid];
      })}
      {sorted.length === 0 && (
        <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginBottom: 16 }}>
          {globalFarmStats.hasStarted && (
            <Alert severity={"warning"}>Nothing to show here</Alert>
          )}
          <div style={{ minHeight: "100vh" }} />
        </Grid>
      )}
    </>
  );
};

export default FarmsList;
